import classNames from 'classnames';
import * as React from 'react';
import { ReactNode } from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';
import { ScopedTooltip } from '../TooltipDecorator/ScopedTooltip';

import './HintButton.css';

export interface HintButtonProps {
    onClick?: () => void;
    onMouseLeave?: () => void;
    onMouseOver?: () => void;
    children: ReactNode;
    isActive: boolean;
    cls?: string;
    tooltipText?: string | JSX.Element;
}

export class HintButton extends React.Component<HintButtonProps> {
    private hintIcon: Shape2 | null;

    render() {
        const {
            cls,
            isActive,
            onClick,
            children,
            onMouseOver,
            onMouseLeave
        } = this.props;

        return (
            <>
                <span
                    className={classNames(
                        cls,
                        Bem.cls({
                            block: 'hint-cell',
                            mods: {
                                active: isActive
                            }
                        })
                    )}
                >
                    {children}
                    <span
                        onClick={onClick}
                        onMouseLeave={onMouseLeave}
                        onMouseOver={onMouseOver}
                    >
                        <Shape2
                            icon={Shape2Icon.warning}
                            width={15}
                            height={15}
                            ref={ref => (this.hintIcon = ref)}
                            theme={Shape2Theme.light}
                            cls={Bem.cls('hint-cell', 'icon')}
                        />
                    </span>
                </span>
                {this.getTooltip()}
            </>
        );
    }

    private getTooltip = () => {
        const { isActive, tooltipText } = this.props;

        if (!tooltipText) {
            return null;
        }

        return (
            <ScopedTooltip
                theme={'white'}
                anchor={this.hintIcon}
                visible={isActive}
                tail={true}
                view={'classic'}
                size={'n'}
                offset={0}
                to={['top', 'bottom']}
            >
                <div className={Bem.cls('hint-button', 'tooltip-content')}>
                    {tooltipText}
                </div>
            </ScopedTooltip>
        );
    };
}
